export const getLocationPropertyValue = (locationProperties, key) => {
    const property = locationProperties.find(p => p.location_property_key?.identifier === key)
    if (!property) return

    let valueType = property.location_property_key.data_type
    if (valueType === 'json') valueType = 'text'
    else if (valueType === 'boolean') valueType = 'int'

    const valueField = `${valueType}_value`

    return property[valueField]
}
